import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { ArrowLeft, Mail, Shield } from "lucide-react";
import { useAuthStore } from "../stores/auth-store";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

const recoverySchema = z.object({
  email: z.string().email("Email inválido"),
});

export default function ForgotPasswordPage() {
  const { requestPasswordRecovery, isLoading } = useAuthStore();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(recoverySchema),
  });

  const onSubmit = async (data) => {
    const result = await requestPasswordRecovery(data.email);
    if (result.success) {
      toast.success(result.message);
    } else {
      toast.error(result.error);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-sm">
        <div className="flex items-center justify-center gap-2 mb-8">
          <Shield className="w-10 h-10 text-secondary" />
          <span className="text-3xl font-bold tracking-tight">KawaFinance</span>
        </div>

        <h1 className="text-2xl font-semibold text-center mb-2">Recuperar senha</h1>
        <p className="text-muted-foreground text-center mb-8">
          Enviaremos um link se o email estiver cadastrado.
        </p>

        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-muted-foreground" />
              <Input
                id="email"
                type="email"
                placeholder="seu@email.com"
                className="pl-10"
                {...register("email")}
                data-testid="recovery-email"
              />
            </div>
            {errors.email && (
              <p className="text-sm text-destructive">{errors.email.message}</p>
            )}
          </div>

          <Button type="submit" className="w-full btn-glow" disabled={isLoading} data-testid="recovery-submit">
            {isLoading ? "Enviando..." : "Enviar link"}
          </Button>
        </form>

        <Link to="/login" className="mt-6 flex items-center justify-center gap-2 text-sm text-primary hover:underline">
          <ArrowLeft className="w-4 h-4" />
          Voltar para login
        </Link>
      </div>
    </div>
  );
}
